export default __webpack_public_path__ + "static/media/assess_opener.07dccbad.svg";